import React from "react";
import {Loader} from "semantic-ui-react";


const style = {
    height: "100vh",
    width: "100%",
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 999,
    background: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
}

const PaymentProcessing = ({loading, isElectronicPayment, strings}) => {
    const [hasToShowProcessingPayment, setHasToShowProcessingPayment] = React.useState(false);
    React.useEffect(() => {
        if (isElectronicPayment && loading) {
            setHasToShowProcessingPayment(true);
        } else if (!loading) {
            setHasToShowProcessingPayment(false);
        }
    }, [loading, isElectronicPayment])

    return (<>
            { hasToShowProcessingPayment &&
            <div style={style}>
                <Loader style={{paddingBottom: "230px"}} active={true} size='massive'/>
                <div style={{textAlign: "center", marginTop: "30px"}}>
                    <h4 className={"primaryHeaderColor"} style={{marginBottom: "10px"}}>
                        {strings.paymentProcessing}
                    </h4>
                    <p>{strings.pleaseDoNotRefresh} <br/>{strings.thisProcessMakeTake}</p>
                </div>
            </div>
        }
        </>
    );
}

export default PaymentProcessing;
